import type { TicketFeedbackMethod, TicketResolutionInput } from "@/api/tickets";
import type { TranslationKey } from "@/locales/i18n";

export const MAX_RESOLUTION_RESULT_LENGTH = 4000;
export const MAX_FEEDBACK_METHOD_OTHER_LENGTH = 100;
export const TICKET_FEEDBACK_METHODS: readonly TicketFeedbackMethod[] = ["phone", "sms", "email", "other"];

export type TicketResolutionErrors = Partial<Record<"result" | "method" | "other", TranslationKey>>;

export function prepareTicketResolution(draft: { result: string; method: TicketFeedbackMethod | ""; other: string }): {
  errors: TicketResolutionErrors;
  input: TicketResolutionInput | null;
} {
  const result = draft.result.trim();
  const other = draft.other.trim();
  const errors: TicketResolutionErrors = {};
  if (!result) errors.result = "tickets.resolution.validation.resultRequired";
  else if (result.length > MAX_RESOLUTION_RESULT_LENGTH) errors.result = "tickets.resolution.validation.resultTooLong";
  if (!draft.method) errors.method = "tickets.resolution.validation.methodRequired";
  if (draft.method === "other") {
    if (!other) errors.other = "tickets.resolution.validation.otherRequired";
    else if (other.length > MAX_FEEDBACK_METHOD_OTHER_LENGTH) errors.other = "tickets.resolution.validation.otherTooLong";
  }

  return {
    errors,
    input:
      Object.keys(errors).length === 0 && draft.method
        ? {
            resolutionResult: result,
            feedbackMethod: draft.method,
            ...(draft.method === "other" ? { feedbackMethodOther: other } : {}),
          }
        : null,
  };
}
